// extracted by mini-css-extract-plugin
export default {"card":"PersonForSlider_card__ISCXW","card_description":"PersonForSlider_card_description__ONdRq"};